import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useAccountAppContext } from '@/app/AccountAppContext'

export const useEmailMfa = () => {
    const { t } = useTranslation()

    const queryClient = useQueryClient()

    const { api, accountKey, showSuccess, showError, clearSuccess } = useAccountAppContext()

    const enable = useMutation({
        mutationFn: () => api.enableEmailFactor(),
        retry: false,
        onSuccess: () => {
            clearSuccess()
        },
        onError: (error) => {
            showError(error instanceof Error ? error.message : t('security.local.email.messages.setupError'))
        },
    })

    const verify = useMutation({
        mutationFn: (code: string) => api.verifyEmailFactor({ code }),
        retry: false,
        onSuccess: async () => {
            showSuccess(t('security.local.email.messages.verified'))
            await queryClient.invalidateQueries({ queryKey: ['account', accountKey, 'security'] })
        },
    })

    const disable = useMutation({
        mutationFn: () => api.disableEmailFactor(),
        retry: false,
        onSuccess: async () => {
            showSuccess(t('security.local.email.messages.disabled'))
            await queryClient.invalidateQueries({ queryKey: ['account', accountKey, 'security'] })
        },
    })

    return { enable, verify, disable }
}
